<template>
<div>
    <v-card>

        <v-toolbar dark flat color="primary">
            <v-toolbar-title>Edit Notes</v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap pa-3 align-center>
            <v-flex xs12 lg4 pa-3>
                <v-select :items="['Kindergarten', '1st grade', '2nd grade', '3rd grade', '4th grade', '5th grade', '6th grade', '7th grade', '8th grade', '9th grade', '10th grade', '11th grade', '12th grade']" label="Choose a grade" v-model="grade"></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 lg6 pa-3>
                <h2 class="display-3 text-xs-right">{{ grade }}</h2>
            </v-flex>
        </v-layout>

        <v-layout row wrap pa-3>

            <v-flex xs12 md10 offset-md1 my-3>
                <v-card>
                    <v-toolbar color="red" class="white--text" mb-2 flat>
                        <h3>Overall Message</h3>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '218' }" v-model="notes.message" name="message">
                        </editor>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1 my-3>
                <v-card>
                    <v-toolbar color="yellow" class="black--text" mb-2 flat>
                        <h3>Monday</h3>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field name="time" label="Time" v-model="notes.m.time"></v-text-field>
                        <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '150' }" v-model="notes.m.msg" name="message">
                        </editor>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1 my-3>
                <v-card>
                    <v-toolbar color="green" class="white--text" mb-2 flat>
                        <h3>Tuesday / Thursday</h3>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field name="time" label="Time" v-model="notes.t.time"></v-text-field>
                        <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '150' }" v-model="notes.t.msg" name="message">
                        </editor>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1 my-3>
                <v-card>
                    <v-toolbar color="blue" class="white--text" mb-2 flat>
                        <h3>Wednesday</h3>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field name="time" label="Time" v-model="notes.w.time"></v-text-field>
                        <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '150' }" v-model="notes.w.msg" name="message">
                        </editor>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1 my-3>
                <v-card>
                    <v-toolbar color="pink" class="white--text" mb-2 flat>
                        <h3>Friday</h3>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field name="time" label="Time" v-model="notes.f.time"></v-text-field>
                        <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '150' }" v-model="notes.f.msg" name="message">
                        </editor>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 md10 offset-md1 my-3>
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="grade === ''" @click="updateNotes">update notes</v-btn>
                </v-layout>
            </v-flex>

        </v-layout>
    </v-card>

    <v-dialog v-model="notesSuccessAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="success">Notes Successfully Updated!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="notesSuccessAlert = false">Ok!</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
    props: {
        semester: {
            type: Object,
            required: true
        }
    },
    components: {
        editor: Editor
    },
    data() {
        return {
            grade: '',
            notesSuccessAlert: false
        }
    },
    mounted() {
        this.$root.$on('resetEditOptions', () => this.grade = '')
    },
    computed: {
        notes() {
            if (this.grade === '') {
                return {
                    message: '',
                    m: {
                        time: '',
                        msg: ''
                    },
                    t: {
                        time: '',
                        msg: ''
                    },
                    w: {
                        time: '',
                        msg: ''
                    },
                    f: {
                        time: '',
                        msg: ''
                    }
                }
            } else {
                switch (this.grade) {
                    case 'Kindergarten':
                        return this.semester.kindergarten
                        break
                    case '1st grade':
                        return this.semester.grade_1
                        break
                    case '2nd grade':
                        return this.semester.grade_2
                        break
                    case '3rd grade':
                        return this.semester.grade_3
                        break
                    case '4th grade':
                        return this.semester.grade_4
                        break
                    case '5th grade':
                        return this.semester.grade_5
                        break
                    case '6th grade':
                        return this.semester.grade_6
                        break
                    case '7th grade':
                        return this.semester.grade_7
                        break
                    case '8th grade':
                        return this.semester.grade_8
                        break
                    case '9th grade':
                        return this.semester.grade_9
                        break
                    case '10th grade':
                        return this.semester.grade_10
                        break
                    case '11th grade':
                        return this.semester.grade_11
                        break
                    case '12th grade':
                        return this.semester.grade_12
                }
            }
        },
    },
    methods: {
        updateNotes() {
            let payload = {
                id: this.semester.id,
                grade: this.grade,
                notes: this.notes
            }
            this.$store.dispatch('updateNotes', payload).then(() => {
                this.notesSuccessAlert = true
            })
        }
    }
}
</script>
